import { Doughnut } from "react-chartjs-2";
import { useState } from "react";
import Icon from "../../../Icons/services/Icon";

const formatearNumero = (valor) =>
  new Intl.NumberFormat("es-CO").format(Number(valor) || 0);
//----------------------------------------------------------------------------------------------------------------------
const calcularPorcentajes = (valores) => {
  const cantidades = valores.map(v => Number(v) || 0);
  const total = cantidades.reduce((acc, v) => acc + v, 0);

  if (total <= 0) {
    return cantidades.map(() => 0);
  }

  // Calculamos con un decimal
  const porcentajes = cantidades.map(v =>
    Math.round((v / total) * 1000) / 10
  );

  // Ver cuánto falta o sobra para llegar a 100
  const suma = porcentajes.reduce((acc, v) => acc + v, 0);
  const diferencia = Math.round((100 - suma) * 10) / 10;

  // Ajustar el porcentaje más grande
  if (diferencia !== 0) {
    const indiceMayor = porcentajes.indexOf(Math.max(...porcentajes));

    porcentajes[indiceMayor] =
      Math.round((porcentajes[indiceMayor] + diferencia) * 10) / 10;
  }

  return porcentajes;
};

//----------------------------------------------------------------------------------------------------------------------
const calcularPorcentaje2 = (valor, total) => {
  const cantidad = Number(valor) || 0;
  const totalTurnos = Number(total) || 0;

  if (totalTurnos <= 0) return 0;

  return ((cantidad / totalTurnos) * 100).toFixed(1);
};
//----------------------------------------------------------------------------------------------------------------------
const ResumenItem = ({ color, titulo, valor, total, porcentaje }) => {
  //const porcentaje = calcularPorcentaje2(valor, total);

  return (
    <div className="flex w-full items-center justify-between gap-8">
      <div className="flex min-w-0 items-center gap-4">
        <span className={`h-5 w-5 shrink-0 rounded-full shadow-sm ${color}`}/>
        <span className="text-[1.2rem] font-medium leading-none text-border xl:text-[1.3rem]">
          {titulo}
        </span>
      </div>

      <div className="flex shrink-0 items-baseline gap-3">
        <span className="min-w-[2.75rem] text-right text-[1.35rem] font-bold leading-none text-gray-500 xl:text-[1.45rem]" >
          {formatearNumero(valor)}
        </span>
        <span className="min-w-[3.5rem] text-right text-base font-medium leading-none text-gray-500 xl:text-lg">
          ({porcentaje}%)
        </span>
      </div>
    </div>
  );
};

//----------------------------------------------------------------------------------------------------------------------
export default function ResumenAtenciones({CantTurnos = 0, datos, Procesos, data, options, plugins,}) {
  const [mostrarServicios, setMostrarServicios] = useState(false);

  const atendidos = Number(datos?.Atendido) || 0;
  const porAtender = Number(datos?.PorAtender) || 0;
  const pendientes = Number(datos?.Pendientes) || 0;
  const enProceso = Number(Procesos?.current) || 0;
  const total = Number(CantTurnos) || 0;
  const porcentajes = calcularPorcentajes([
  atendidos,
  porAtender,
  pendientes,
  enProceso
]);
  return (
    <section className="w-full rounded-2xl border border-slate-200 bg-white px-4 py-5 shadow-[0_10px_28px_rgba(15,23,42,0.10) sm:px-5 lg:px-6">
         {/* Encabezado */}
        <header className="mb-5 flex flex-col gap-4 md:flex-row md:items-start md:justify-between">
            <div>
              <h2 className="text-xl font-semibold text-gray-500 xl:text-2xl">
                Resumen de atenciones
              </h2>
              <p className="mt-1 text-sm text-gray-400 xl:text-base">
                 Estado general de los turnos
              </p>
            </div>
        </header>
           {/* Contenido agrupado */}
        <div className="mx-auto flex max-w-[70rem] flex-col items-center justify-center gap-6 lg:flex-row lg:gap-8 xl:gap-10 ">
            {/* Dona */}
          <div className="flex shrink-0 items-center justify-center">
             <div className="relative h-[15rem] w-[15rem] sm:h-[16rem] sm:w-[16rem] xl:h-[18rem] xl:w-[18rem]">
                <Doughnut data={data} options={options} plugins={plugins}/>
             </div>
          </div>
            {/* Leyenda */}
          <div className="flex w-full max-w-[28rem] flex-col gap-6 xl:max-w-[30rem] xl:gap-7 " >
             <ResumenItem color="bg-atendido"   titulo="Atendidos"   valor={atendidos}  total={total} porcentaje={porcentajes[0]}/>
             <ResumenItem color="bg-poratender" titulo="Por atender" valor={porAtender} total={total} porcentaje={porcentajes[1]}/>
             <ResumenItem color="bg-pendiente"  titulo="Pendientes"  valor={pendientes} total={total} porcentaje={porcentajes[2]}/>
             <ResumenItem color="bg-enproceso"  titulo="En proceso"  valor={enProceso}  total={total} porcentaje={porcentajes[3]}/>
          </div>
            {/* Total */}
          <div className="flex w-full min-h-[9rem] flex-col items-center justify-center border-t border-gray-400
                          pt-6 lg:w-[17rem] lg:min-h-[14rem] lg:border-l lg:border-t-0 lg:pl-9 lg:pt-0 ">
            <span className="text-[4.5rem] font-bold leading-none tracking-tight text-gray-400 xl:text-[5rem]">
               {formatearNumero(total)}
            </span>
            <span className="mt-4 text-xl font-medium text-border xl:text-2xl">
               Total de turnos
            </span>
          </div>
        </div>
    </section>
  );
}